import { Group, PortalRole } from '@edl-development/edl-common';

export class AllUsersSearchRequest {
    PortalRoles: PortalRole[];
    PortalGroups: Group[];
    AccessRoles: number[];
}